import { useEffect, useState } from 'react';
import { BASE_URL } from '../settings';

const useServerStatus = () => {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [isServerDown, setIsServerDown] = useState(false);
  const [serverDownMessage, setServerDownMessage] = useState("");
  const [maintenanceMessage, setMaintenanceMessage] = useState("");
  const [maintenanceSubText, setMaintenanceSubText] = useState("");
  const [maintenanceStartTime, setMaintenanceStartTime] = useState(null);
  const [maintenanceEndTime, setMaintenanceEndTime] = useState(null);

  useEffect(() => {
    const handleMaintenance = (e) => {
      setIsMaintenance(true);
      setMaintenanceMessage(e.detail?.message);
      setMaintenanceSubText(e.detail?.subText);
      setMaintenanceStartTime(e.detail?.startTime);
      setMaintenanceEndTime(e.detail?.endTime);
    };

    const handleServerDown = (e) => {
      setIsServerDown(true);
      setServerDownMessage(e.detail?.subText || "");
    };

    window.addEventListener('maintenance_active', handleMaintenance);
    window.addEventListener('server_down', handleServerDown);
    return () => {
      window.removeEventListener('maintenance_active', handleMaintenance);
      window.removeEventListener('server_down', handleServerDown);
    };
  }, []);

  useEffect(() => {
    const checkServerHealth = async () => {
      try {
        const gatewayBaseUrl = BASE_URL.replace(/\/api\/?$/, '');
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        const response = await fetch(`${gatewayBaseUrl}/actuator/health`, {
          method: 'GET',
          mode: 'cors',
          signal: controller.signal
        });
        
        clearTimeout(timeoutId);
        if (response.status >= 500) {
          setIsServerDown(true);
          setServerDownMessage("Our servers are currently experiencing issues. Please try again in a few minutes.");
        } else if (response.ok) {
          const data = await response.json();
          if (data.status && data.status !== 'UP') {
            setIsServerDown(true);
            setServerDownMessage("Our servers are currently experiencing issues. Please try again in a few minutes.");
          }
        }
      } catch (error) {
        console.error("Server health check failed:", error);
        setIsServerDown(true);
        setServerDownMessage("Our servers are currently unreachable. This could be due to a temporary outage or network issue. Please try again in a few minutes.");
      }
    };
    checkServerHealth();
  }, []);

  return {
    isMaintenance,
    isServerDown,
    serverDownMessage,
    maintenanceMessage,
    maintenanceSubText,
    maintenanceStartTime,
    maintenanceEndTime,
  };
};

export default useServerStatus;
